export default class FriSelection {

    constructor(el) {
        this.el = el;
    }

    replaceSelectedText(text) {
        let sel = this.getInputSelection(this.el), val = this.el.value;
        this.el.value = val.slice(0, sel.start) + text + val.slice(sel.end);
        this.setCaretToPos(sel.start+text.length);
    }

    getInputSelection() {
        var el = this.el;
        var start = 0, end = 0, normalizedValue, range,
            textInputRange, len, endRange;
        if (typeof el.selectionStart === "number" && typeof el.selectionEnd === "number") {
            start = el.selectionStart;
            end = el.selectionEnd;
        } else {
            range = document.selection.createRange();

            if (range && range.parentElement() === el) {
                len = el.value.length;
                normalizedValue = el.value.replace(/\r\n/g, "\n");
                textInputRange = el.createTextRange();
                textInputRange.moveToBookmark(range.getBookmark());
                endRange = el.createTextRange();
                endRange.collapse(false);
                if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                    start = end = len;
                } else {
                    start = -textInputRange.moveStart("character", -len);
                    start += normalizedValue.slice(0, start).split("\n").length - 1;

                    if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                        end = len;
                    } else {
                        end = -textInputRange.moveEnd("character", -len);
                        end += normalizedValue.slice(0, end).split("\n").length - 1;
                    }
                }
            }
        }
        return {
            start: start,
            end: end,
            content: el.value.substring(start, end)
        };
    }
    setSelectionRange(selectionStart, selectionEnd) {
        let input = this.el;
        if (input.setSelectionRange) {
            input.focus();
            input.setSelectionRange(selectionStart, selectionEnd);
        }
        else if (input.createTextRange) {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', selectionEnd);
            range.moveStart('character', selectionStart);
            range.select();
        }
    }
    setCaretToPos(pos) {
        this.setSelectionRange(pos, pos);
    }
}


// WEBPACK FOOTER //
// ./src/scripts/kbd/FriSelection.js